"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ClaimCompleted {
    constructor(details, documents, contact) {
        this.details = details;
        this.documents = documents;
        this.contact = contact;
    }
    static fromObj(data = {}) {
        return {
            details: !!data.details,
            documents: !!data.documents,
            contact: !!data.contact
        };
    }
}
exports.default = ClaimCompleted;
//# sourceMappingURL=claimCompleted.class.js.map